import { GetStatusIcon } from "client/utils/IconsUtil";
import AssetOrderDetailViewBreadcrumb from "./AssetOrderDetailViewBredcrumb"
import { CONSTANTS } from "client/utils/constants";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { operations } from "redux/Navigation";
import selectors from "redux/Navigation/selectors";
import { setTransferOrderById } from "Store/Transfer/Transfer/TransferOrderByIdAction"
import TransferAction from "Store/Component/Transfer/TransferAction";

const AssetOrderDetailViewBreadcrumbContainer = () => {
    
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const navDispatch = operations.dispatchNav(dispatch);
    const [headerNavItem, setHeaderNavItem] = useState("home");

    const { headerNav, transferOrderByIdData, afeOrderByIdData}: any = useSelector((state: any) => ({
        headerNav: selectors.GetHeaderNav(state),
        transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
        afeOrderByIdData: state.TransferReducer.afeOrderByIdData
    }));

    let {pagename, activeassetnumber, requesttype } = useParams();

    useEffect(() => {
        setHeaderNavItem(headerNav);
    }, [headerNav]);
    
    const iconReturn = (status: any) => {
        let src = GetStatusIcon(status);
        let classNameTemp = '';
        if(status === CONSTANTS.ORDER_STATUS.COMPLETED){
          classNameTemp = 'completedicon statusIcon'; 
        }else if(status === CONSTANTS.ORDER_STATUS.FLEET_PROCESSING){
          classNameTemp = 'fleetprocessingicon statusIcon'; 
        }else {
          classNameTemp = 'me-2 iconMargin';
        }
        return (
          <img
            src={src?.icon}
            alt={status}
            title={status}
            className={classNameTemp}
          />
        ) 
      };

      const breadcrumlist = [
        {
          text: pagename == 'activeasset' ? "Active Assets Drill Through" : headerNavItem === "Customer My Orders" ? "Orders" : headerNavItem,
          key: "f1",
          href: "/ordermanagement",
          onClick: (e: any) => {
            e.preventDefault();
            if(pagename === CONSTANTS.PAGE_NAME.ASSET){
              navDispatch('Asset')
            }else if(pagename == 'activeasset'){
              navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
            }else{
              navDispatch('Home')
            }   
            if(pagename != 'activeasset'){    
             navigate('/ordermanagement');
            }
          },
        },
        { text: "Order Detail", key: "f4" },
      ];
    
      const handleClickBack = () => {
        if(pagename === CONSTANTS.PAGE_NAME.ASSET){
          navDispatch('Asset')
        }else if(pagename == 'activeasset'){
          navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
        }else{
          navDispatch('Home')
        }
        dispatch(setTransferOrderById({}))
        dispatch(TransferAction.setAfeOrderByIdData({}))
        if(pagename != 'activeasset'){  
        navigate('/ordermanagement');
        }
      }
    return(
        <AssetOrderDetailViewBreadcrumb  orderDetails={requesttype == CONSTANTS.AFEREQUEST ? afeOrderByIdData : transferOrderByIdData} iconReturn={iconReturn} breadcrumlist={breadcrumlist} handleClickBack={handleClickBack}/>
    )
}

export default AssetOrderDetailViewBreadcrumbContainer